import React from 'react';
import TrueImpactText from '../../design-system/base/TrueImpactText';
import {
  FeedbackFilter,
  FeedbackFilters,
  FilterPill,
} from './FeedbackDashboardFilterBar';
import {
  FeedbackFilterProps,
  FeedbackSingleFilterProps,
} from './FiltersDropdown/FeedbackFilterDropdown';

const getFilterNames = (filters: FeedbackFilters): FeedbackFilter[] => {
  const names: FeedbackFilter[] = [];
  for (const key in filters) {
    const element = filters[key];
    element.selected && names.push(element);
  }
  return names;
};

export interface FeedbackDashboardAppliedFiltersProps {
  donorNames: FeedbackFilterProps;
  relationships: FeedbackFilterProps;
  portfolioNames: FeedbackFilterProps;
  cycles: FeedbackFilterProps;
  status: FeedbackFilterProps;
  trueImpactStaff: FeedbackFilterProps;
  dueDates: FeedbackSingleFilterProps<string>;
  charityNavigator: FeedbackFilterProps;
  years: FeedbackFilterProps;
  sortBy: FeedbackSingleFilterProps<string>;
}

const FeedbackDashboardAppliedFilters: React.FC<FeedbackDashboardAppliedFiltersProps> = ({
  donorNames,
  relationships,
  portfolioNames,
  cycles,
  status,
  trueImpactStaff,
  dueDates,
  charityNavigator,
  years,
}) => {
  const donors = getFilterNames(donorNames.filters);
  const relations = getFilterNames(relationships.filters);
  const portfolio = getFilterNames(portfolioNames.filters);
  const cycleTypes = getFilterNames(cycles.filters);
  const statusType = getFilterNames(status.filters);
  const staff = getFilterNames(trueImpactStaff.filters);
  const due = getFilterNames(dueDates.filters);
  const cn = getFilterNames(charityNavigator.filters);
  const year = getFilterNames(years.filters);

  return (
    <div className="applied_filters__wrapper">
      <div className="heading-label">Filters Applied</div>
      {donors.length > 0 ||
      relations.length > 0 ||
      portfolio.length > 0 ||
      cycleTypes.length > 0 ||
      statusType.length > 0 ||
      staff.length > 0 ||
      due.length > 0 ||
      year.length > 0 ||
      cn.length > 0 ? (
        <div className="filter_pills__wrapper">
          <FilterPill
            filterType="Donor"
            filters={donors}
            onClick={donorNames.onRemove}
          />
          <FilterPill
            filterType="Manager"
            filters={relations}
            onClick={relationships.onRemove}
          />
          <FilterPill
            filterType="Portfolio"
            filters={portfolio}
            onClick={portfolioNames.onRemove}
          />
          <FilterPill
            filterType="Cycle Type"
            filters={cycleTypes}
            onClick={cycles.onRemove}
          />
          <FilterPill
            filterType="Status"
            filters={statusType}
            onClick={status.onRemove}
          />
          <FilterPill
            filterType="Staff"
            filters={staff}
            onClick={trueImpactStaff.onRemove}
          />
          <FilterPill
            filterType="Due Date"
            filters={due}
            onClick={dueDates.onClear}
          />
          <FilterPill
            filterType="Charity Navigator"
            filters={cn}
            onClick={charityNavigator.onRemove}
          />
          <FilterPill
            filterType="Year"
            filters={year}
            onClick={years.onRemove}
          />
        </div>
      ) : (
        <TrueImpactText variant="body-small" color="whiteBase">
          No filters applied
        </TrueImpactText>
      )}
    </div>
  );
};

export default FeedbackDashboardAppliedFilters;
